import React from "react";
import { IoMdClose } from "react-icons/io";

const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-start py-20 justify-center bg-black bg-opacity-50 z-50" onClick={onClose}>
            <div className="bg-white p-6 shadow-lg w-[700px] rounded" onClick={(e)=>e.stopPropagation()}>
                <div className="flex items-center justify-between mb-4">
                    <h2 className="font-[500] ">{title}</h2>
                    <div onClick={onClose} className="cursor-pointer">
                        <IoMdClose />
                    </div>
                </div>
                <div className="mb-4">{children}</div>
                
            </div>
        </div>
    );
};

export default Modal;
